var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.campaign.click_rate !== null)?_c('span',{staticClass:"campaign-click-rate"},[_c('abbr',{attrs:{"title":"Click through rate"}},[_vm._v("CTR")]),_vm._v(" "),_c('percent-rate',{attrs:{"rate":_vm.campaign.click_rate,"min_rate":_vm.min_rate(_vm.campaign.channel_title, 'click')}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }